<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center" v-if="administrador === true">
          <basic-toolbar :title="'Concluir ou desfazer a finalização de ações de extensão aguardando relatório'"></basic-toolbar>
          <v-card-text>
            <v-data-table
            :headers="headers"
            :items="listaProjetos"
            :search="search"
            :no-data-text="'Não há nenhuma ação aguardando relatório'"
            must-sort
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :items-per-page="itemsPerPage"
            :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
            >
              <template v-slot:item.titulo="props">
                <router-link :to="{ name: 'ProjetoFormulario', params: { idProjeto: props.item.idProjeto }}">{{ props.item.titulo }}</router-link>
              </template>

              <!-- Ícones de "Concluir" e "Desfazer Finalização" da coluna "Opções" -->
              <template v-slot:item.opcoes="props">

                <!-- Ícone de "Concluir" -->
                <c-tooltip-btn
                icon="folder"
                color="brown lighten-1"
                tooltip="Concluir"
                @click="goConcluirAcao(props.item.idProjeto)"
                ></c-tooltip-btn>

                <!-- Ícone de "Desfazer Finalização" -->
                <c-tooltip-btn
                icon="undo"
                color="primary"
                tooltip="Desfazer Finalização"
                @click="goDesfazerFinalizacao(props.item.idProjeto)"
                ></c-tooltip-btn>

              </template>

              <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
                Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaProjetos.length }} projetos
              </template>
            </v-data-table>
            <br>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import TootipButton from '@/components/c-tooltip-btn'
  import dates from '@/utils/dates'
  import projetos from '@/utils/projetos'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      formularioValido: false,
      dates: dates,
      pesquisa: {
        situacao: [20]
      },
      listaProjetos: [],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: -1,
      opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
      headers: [
        { text: 'Número', align: 'center', value: 'idProjeto' },
        { text: 'Título', align: 'center', value: 'titulo' },
        { text: 'Classificação Primária', align: 'center', value: 'classificacaoPrimaria' },
        { text: 'Classificação Secundária', align: 'center', value: 'classificacaoSecundaria' },
        { text: 'Situação', align: 'center', value: 'situacao' },
        { text: 'Coordenador', align: 'center', value: 'nomeCoordenador' },
        { text: 'Opções', align: 'center', value: 'opcoes' }
      ]
    }),
    computed: {
      ...mapGetters('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']),
      goConcluirAcao (idProjeto) {
        this.$router.push({name: 'ConcluirProjeto', params: {idProjeto: idProjeto}})
      },
      goDesfazerFinalizacao (idProjeto) {
        this.$router.push({name: 'DesfazerFinalizacao', params: {idProjeto: idProjeto}})
      },
      pesquisar () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ações.' })
        projetos.getConsultaProjetos(this.pesquisa)
        .then(response => {
          this.listaProjetos = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.listaProjetos = []
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ações.' })
        })
      }
    },
    mounted () {
      this.pesquisar()
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-tooltip-btn': TootipButton
    }
  }
</script>



// WEBPACK FOOTER //
// projetos-concluir-tabela.vue?5aa75cfe